import { GenericData, getStatusCount, StatusKey } from 'components/StatusSummary/helper';
import { useTranslation } from 'react-i18next';
import { severityMap } from '../../pages/Asset/tabs/Cases/components/Filters/CasesSummaryPanel';
import { SeverityPanel } from '../../pages/Asset/tabs/Cases/components/Filters/SeverityPanel';
import { severityMaps } from 'components/SeverityPanel';
import { EventsContextType } from 'pages/Asset/tabs/Events/Events.context';
import { CasesContextType } from '../../pages/Asset/tabs/Cases/Cases.context';
import { useMemo } from 'react';
import './style.scss';
import { MULTIVALUE_MODE } from 'hooks/useFilters/useFilters';

export const pageEnum = {
  cases: 'case',
  events: 'event_page',
} as const;

interface SeverityProps {
  page: (typeof pageEnum)[keyof typeof pageEnum];
  context: EventsContextType | CasesContextType;
}

export const Severity: React.FC<SeverityProps> = ({ context, page }) => {
  const { t } = useTranslation();
  const { dataToCount, allActiveFilters, onChangeFilters, showAnalytics } = context || {};

  const keyName = 'severity';
  const keyMap = page === pageEnum.events ? severityMaps[keyName] : severityMap;

  const statusCounts = getStatusCount(
    keyName,
    dataToCount(keyName) as GenericData[],
    Object.keys(keyMap) as StatusKey[],
  );

  const handleSeverityChange = (severity: string[]) => {
    onChangeFilters({
      filterName: keyName,
      filterValue: severity,
      multivalueMode: MULTIVALUE_MODE.MERGE_WITH_PREVIOUS,
    });
  };

  const getLabelMemo = useMemo(
    () => (key: string) => t(`${page}:status_count_panel.severity.${key}`),
    [t, page],
  );

  const severityAnalyticsClass = showAnalytics ? 'severity-box-analytics' : '';

  return (
    <div className={`severity-box ${severityAnalyticsClass}`}>
      <SeverityPanel
        statusCounts={statusCounts}
        keyMap={keyMap}
        getLabel={getLabelMemo}
        severityKey={keyName}
        onClick={handleSeverityChange}
        selectedSeverity={allActiveFilters[keyName] ?? []}
      />
    </div>
  );
};
